import { render, staticRenderFns } from "./ClientUserDevice.vue?vue&type=template&id=f13c8064"
import script from "./ClientUserDevice.vue?vue&type=script&lang=js"
export * from "./ClientUserDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports